// extracted by mini-css-extract-plugin
module.exports = {"link":"funding-request-entity_link__tU8s9","red":"funding-request-entity_red__2Lz6g"};